import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'Faq/SectionsWithQuestions', method: 'GET', body: null, token: token })
}
